import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-3 py-3" }
const _hoisted_2 = { class: "flex flex-start items-center gap-3" }
const _hoisted_3 = { class: "flex items-center justify-center h-8 w-8 bg-primary text-primary-foreground rounded-full" }
const _hoisted_4 = { class: "flex-1 text-left text-sm font-semibold text-wrap break-words overflow-hidden text-ellipsis whitespace-nowrap max-h-full" }




export default /*#__PURE__*/_defineComponent({
  __name: 'SectionComponent',
  props: {
  title: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})